// Note: FirmInvitation and GroupInvitation for invitation list pages
// are re-exported from ./firms and ./groups respectively.
// UI-specific types (no access-ws-client equivalent)
export const EntityType = ['firm', 'firm-membership', 'group', 'user'];
export var TradingPlatform;
(function (TradingPlatform) {
    TradingPlatform["Alpha"] = "thinkalpha";
    TradingPlatform["Sterling"] = "sterling";
    TradingPlatform["Takion"] = "takion";
    TradingPlatform["Lightspeed"] = "lightspeed";
    TradingPlatform["DAS"] = "das";
})(TradingPlatform || (TradingPlatform = {}));
//# sourceMappingURL=index.js.map